<div 
  class="offline-indicator"
  [class.position-fixed]="position === 'fixed'"
  [class.position-top]="position === 'top'"
  [class.position-bottom]="position === 'bottom'"
  [class.compact]="compact"
  [class]="getConnectionClass()">
  
  <!-- Compact View -->
  <div *ngIf="compact" class="compact-indicator">
    <div class="d-flex align-items-center gap-2">
      <!-- Connection Status -->
      <div class="connection-status">
        <i [class]="getConnectionIcon()" [title]="getConnectionText()"></i>
      </div>
      
      <!-- Sync Status -->
      <div *ngIf="showSyncStatus" class="sync-status">
        <i [class]="getSyncIcon()" [title]="getSyncText()"></i>
        <span *ngIf="syncQueueCount > 0" class="badge bg-warning ms-1">{{ syncQueueCount }}</span>
      </div>
      
      <!-- Update Available -->
      <div *ngIf="updateAvailable" class="update-available">
        <button 
          class="btn btn-sm btn-primary" 
          (click)="activateUpdate()"
          title="Update available - Click to reload">
          <i class="fas fa-download"></i>
        </button>
      </div>
    </div>
  </div>
  
  <!-- Full View -->
  <div *ngIf="!compact" class="full-indicator">
    <div class="container-fluid">
      <div class="row align-items-center">
        <!-- Connection Info -->
        <div class="col-md-4">
          <div class="d-flex align-items-center">
            <i [class]="getConnectionIcon()"></i>
            <div class="ms-2">
              <div class="fw-semibold">{{ getConnectionText() }}</div>
              <small *ngIf="showNetworkInfo && networkStatus" class="text-muted">
                {{ formatConnectionType() }}
                <span *ngIf="networkStatus.downlink > 0"> • {{ formatConnectionSpeed() }}</span>
                <span *ngIf="networkStatus.saveData"> • Data Saver</span>
              </small>
            </div>
          </div>
        </div>
        
        <!-- Sync Status -->
        <div *ngIf="showSyncStatus" class="col-md-4">
          <div class="d-flex align-items-center">
            <i [class]="getSyncIcon()"></i>
            <div class="ms-2">
              <div class="fw-semibold">{{ getSyncText() }}</div>
              <small class="text-muted" *ngIf="offlineDataCount > 0">
                {{ offlineDataCount }} items stored offline
              </small>
            </div>
          </div>
        </div>
        
        <!-- Actions -->
        <div class="col-md-4 text-end">
          <div class="btn-group btn-group-sm">
            <!-- Manual Sync -->
            <button 
              *ngIf="networkStatus?.isOnline && syncQueueCount > 0"
              class="btn btn-outline-primary" 
              (click)="triggerSync()"
              [disabled]="syncInProgress"
              title="Sync pending data">
              <i class="fas fa-sync" [class.fa-spin]="syncInProgress"></i>
              Sync
            </button>
            
            <!-- Update Available -->
            <button 
              *ngIf="updateAvailable"
              class="btn btn-primary" 
              (click)="activateUpdate()"
              title="Update available - Click to reload">
              <i class="fas fa-download me-1"></i>
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Offline Alert -->
  <div *ngIf="!networkStatus?.isOnline && !compact" class="offline-alert">
    <div class="alert alert-warning mb-0">
      <div class="d-flex align-items-center">
        <i class="fas fa-exclamation-triangle me-2"></i>
        <div class="flex-grow-1">
          <strong>You're currently offline</strong>
          <div class="small">
            Your changes will be saved locally and synced when you're back online.
          </div>
        </div>
        <button 
          *ngIf="syncQueueCount > 0"
          class="btn btn-sm btn-outline-warning ms-2"
          disabled
          title="Will sync when online">
          <i class="fas fa-clock me-1"></i>
          {{ syncQueueCount }} pending
        </button>
      </div>
    </div>
  </div>
</div>